// removed by extract-text-webpack-plugin
module.exports = {"InformationFormsContainer":"_3ObsGb0_tGJJ2oQIujpJh-","InformationFormsWrapper":"_2mLEVk5HIV-MXuyzbO1zz-","FormStyle":"hbdNfHrHroy3tchfH3fsV","DisabledFormStyle":"gfeQj_yOW9nzDZ5FU6dXR"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Forms/TextInput/style.css
// module id = 1392
// module chunks = 0